"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var countries_geo_1 = require("./countries.geo");

var isoCodes = countries_geo_1.default.features.map(function (_ref) {
  var I = _ref.I;
  return I;
});